module.exports = __webpack_public_path__ + "static/media/rigved_animated.d26902d4.png";